import Vue from "vue";
import Vuex from "vuex";
import axios from "@/config/axios";

Vue.use(Vuex);

const x = (group = [], result = {}) => {
  group.forEach(item => {
    let key = item.replace(/(^\.\/)|(\.js)/g, "");
    result[key] = file(item).default || file(item);
  });
  return result;
};
const file = require.context("./module", false, /\.js$/);

export default new Vuex.Store({
  state: {
    axios
  },
  mutations: {},
  actions: {},
  modules: x(file.keys())
});
